export const scopes = {
  canCreateProject: 'project-create',
} as const
